<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!-- 사업장 -->
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!-- 심사기간(년도) -->
          <c-datepicker
            :range="true"
            default="today"
            label="LBL0010160"
            name="year"
            v-model="searchParam.year"
          />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!--심사대상부서-->
          <c-dept type="search" :isFirstValue="false" label="LBL0010161" name="dept1" v-model="searchParam.dept1" />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!--심사주관부서-->
          <c-dept type="search" label="LBL0010162" name="dept2" v-model="searchParam.dept2" />
        </div>
      </template>
    </c-search-box>
    <!--안전보건 외부심사 결과목록-->
    <c-table
      ref="table"
      title="LBL0010163"
      :columns="grid.columns"
      :data="grid.data"
      @linkClick="linkClick"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <q-btn-group outline >
          <!--등록-->
          <c-btn v-if="editable" label="LBLREG" icon="add" @btnClicked="openPop" />
          <!--검색-->
          <c-btn label="LBLSEARCH" icon="search" @btnClicked="getList" />
        </q-btn-group>
      </template>
    </c-table>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: 'outernal-manage',
  data() {
    return {
      searchParam: {
        plantCd: null,
        year: '',
        dept1: '',
        dept2: '',
      },
      popupOptions: {
        isFull: true,
        target: null,
        title: '',
        visible: false,
        top: '',
        param: {},
        closeCallback: null,
      },
      grid: {
        columns: [
          {
            name: 'plantName',
            field: 'plantName',
            //사업장
            label: 'LBLPLANT',
            align: 'center',
            style: 'width:100px',
            sortable: true,
          },
          {
            name: 'outernalResultName',
            field: 'outernalResultName',
            //외부심사명
            label: 'LBL0010164',
            align: 'left',
            sortable: true,
            style: 'width:300px',
            type: 'link'
          },
          {
            name: 'auditPeriod',
            field: 'auditPeriod',
            //심사기간
            label: 'LBL0010160',
            align: 'center',
            style: 'width:150px',
            sortable: true,
          },
          {
            name: 'auditTargetDeptName',
            field: 'auditTargetDeptName',
            //심사대상부서
            label: 'LBL0010161',
            align: 'center',
            style: 'width:120px',
            sortable: true,
          },
          {
            name: 'auditDeptName',
            field: 'auditDeptName',
            //심사주관부서
            label: 'LBL0010162',
            align: 'center',
            style: 'width:120px',
            sortable: true,
          },
        ],
        data: [],
      },
      editable: true,
      listUrl: '',
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.listUrl = selectConfig.sai.outernal.result.list.url;
      // code setting
      // list setting
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    linkClick(row) {
      this.openPop(row);
    },
    openPop(row) {
      this.popupOptions.title = 'LBL0010165';   //외부심사 결과 상세
      this.popupOptions.param = {
        saiOuternalResultId: row ? row.saiOuternalResultId : '',
      };
      this.popupOptions.target = () => import(`${'./outernalDetail.vue'}`);
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getList();
    },
  }
};
</script>
